function updatePrice() {
    const productData = document.querySelector(".product-single__meta");
    const mainProductCont = productData?.parentElement;
    const originalValue = document.querySelector(".shipmain .money")
    const additionalValue = mainProductCont.querySelector(".gpo-total-text span");
    const currentQty = document.querySelector(".product-form__input").value || 1;
    if (originalValue && additionalValue) {
        const ogValue = parseFloat(originalValue.textContent.replace("$", "").trim()) || 0;
        const adValue = parseFloat(additionalValue.textContent.replace("$", "").trim()) || 0;
        const totalValue = `$${((ogValue * currentQty) + adValue).toFixed(2)}`;
        const asgTotalPrice = document.querySelector(".custom-total-price .atc-total-price");
        if (!asgTotalPrice) return;
        asgTotalPrice.textContent = totalValue;
    } else if (originalValue && currentQty) {
        const ogValue = parseFloat(originalValue.textContent.replace("$", "").trim()) || 0;
        const totalValue = `$${(ogValue * currentQty).toFixed(2)}`;
        const asgTotalPrice = document.querySelector(".custom-total-price .atc-total-price");
        if (!asgTotalPrice) return;
        asgTotalPrice.textContent = totalValue;
    }
}

document.addEventListener("change", (e) => {
    if (!e.target.closest(".qtyField")) return;
    updatePrice();
})

document.addEventListener("click", (e) => {
    if (!e.target.closest(".qtyField")) return;
    updatePrice();
})

document.addEventListener("DOMContentLoaded", function () {
    const productData = document.querySelector(".product-single__meta");
    const mainProductCont = productData?.parentElement;

    const priceObserver = new MutationObserver(updatePrice);
    priceObserver.observe(mainProductCont.querySelector("form"), {
        subtree: true,
        attributes: true,
    })

    waitForElement(".gpo-container", (engravingAppCont) => {
        if (document.querySelector(".ASG-001-eng-top") || !window.engravings_settings.engraving_title) return;

        const engravingTop = document.createElement("div");
        engravingTop.classList.add("ASG-001-eng");
        engravingTop.innerHTML = `
          <div class="ASG-001-eng-top">
            <div class="ASG-001-eng-title">
              ${window.engravings_settings.engraving_title_icon}
              <h3>${window.engravings_settings.engraving_title}</h3>
            </div>
            ${window.innerWidth <= 768
                ? `<a class="ASG-001-eng-samples" href="${window.engravings_settings.engraving_cta_link}">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M12 10.75C12.4142 10.75 12.75 11.0858 12.75 11.5V16.5C12.75 16.9142 12.4142 17.25 12 17.25C11.5858 17.25 11.25 16.9142 11.25 16.5V11.5C11.25 11.0858 11.5858 10.75 12 10.75Z" fill="black"/>
                            <path d="M12 9C12.5523 9 13 8.55228 13 8C13 7.44772 12.5523 7 12 7C11.4477 7 11 7.44772 11 8C11 8.55228 11.4477 9 12 9Z" fill="black"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M3.25 12C3.25 7.16751 7.16751 3.25 12 3.25C16.8325 3.25 20.75 7.16751 20.75 12C20.75 16.8325 16.8325 20.75 12 20.75C7.16751 20.75 3.25 16.8325 3.25 12ZM12 4.75C7.99594 4.75 4.75 7.99594 4.75 12C4.75 16.0041 7.99594 19.25 12 19.25C16.0041 19.25 19.25 16.0041 19.25 12C19.25 7.99594 16.0041 4.75 12 4.75Z" fill="black"/>
                        </svg>
                    </a>`
                : `<a class="ASG-001-eng-samples" href="${window.engravings_settings.engraving_cta_link}">
                    ${window.engravings_settings.engraving_cta}
                   </a>`
            }
          </div>
          <p class="ASG-001-eng-desc">
            ${window.engravings_settings.engraving_description}
          </p>
        `;

        engravingAppCont.prepend(engravingTop);

        waitForElement(".ASG-001-eng-samples", (el) => {
            el.textContent = "See Font Samples";
        });

        const firstOption = engravingAppCont.querySelector("#select-1").querySelectorAll("option")[1];
        if (firstOption) {
            firstOption.textContent = firstOption.textContent.replace(window.engravings_settings.engraving_text_to_remove, "").trim();
        }
    });

    // Generic function to add appropriate heading based on label content
    function addAppropriateHeading(element) {
        const label = element.querySelector('.gpo-label .label-content');
        
        if (!label) return;
        
        const labelText = label.textContent.trim();
        
        // Check if it's Gift Wrapping
        if (labelText.includes('Gift Wrapping')) {
            if (!element.querySelector('.custom-giftwrap-heading')) {
                const giftHeading = document.createElement("div");
                giftHeading.classList.add("custom-giftwrap-heading");
                giftHeading.innerHTML = `<h3>Gift wrapping options</h3>`;
                element.prepend(giftHeading);
            }
        } 
        // Check if it's any Font selection (covers Engraving Font, Monogram Font, etc.)
        else if (labelText.includes('Font')) {
            if (!element.querySelector('.custom-font-heading')) {
                const fontHeading = document.createElement("div");
                fontHeading.classList.add("custom-font-heading");
                fontHeading.innerHTML = `<h3>Font Selection</h3>`;
                element.prepend(fontHeading);
            }
        }
    }

    // Handle all possible image-swatches elements (1-10 to be safe)
    for (let i = 1; i <= 10; i++) {
        waitForElement(`[data-element-id="image-swatches-${i}"]`, addAppropriateHeading);
    }
});

function waitForElement(selector, callback, timeout = 7000) {
    const intervalTime = 100;
    let elapsedTime = 0;

    const interval = setInterval(() => {
        const element = document.querySelector(selector);
        if (element) {
            clearInterval(interval);
            callback(element);
        } else if (elapsedTime >= timeout) {
            clearInterval(interval);
        }
        elapsedTime += intervalTime;
    }, intervalTime);
}